module.exports = __webpack_public_path__ + "img/ExternalFireDetails-min.2dbf49f0.png";